import {Integer} from '../types/Integer';
import {isResponsiveValue, ResponsiveValue} from '../types/ResponsiveValue';
import {toSpacingValue} from './getSpacingStyle';

/**
 * Resolves a spacing prop value to a string for inline styles
 * For responsive values, uses the base value
 */
export function resolveSpacingValue(value: Integer | ResponsiveValue<Integer>): string | undefined {
  if (isResponsiveValue(value)) {
    return value.base !== undefined ? toSpacingValue(value.base) : undefined;
  }
  return toSpacingValue(value);
}
